var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xxl-12"},[_c('DomainDetails'),_c('UrlsList')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }